import { ReportRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';

class ReportService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new ReportRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	sendReport(sendReportParams) {
		var url = this.routeService.sendReport(sendReportParams);
		return this.apiClient.post(url, sendReportParams);
	}
}

export default ReportService;
